<template>
  <div>
    <form-header
        v-if="mode === 'EDIT_AS_ADMIN' ? (!formConfig.restrictedWrite || permissions[formConfig.effectivePermissionWrite]) : mode !== 'NEW'"
        :save-edit-mode="readOnlyMode ? 'EDIT' : 'SAVE'"
        @edit="edit"
        @save="saveNoClose"
        :save-enabled="form.canSubmit && errorOwnerFeedback.length <= 0"
    >
    </form-header>
    <v-box ref="vbox" :scrollable="true">
      <b-container class="pt-1 pl-2" fluid="true">
        <b-row no-gutters>
          <b-col>
            <b-container>
              <b-row>
                <b-col order-lg="1" lg="6">
                  <b-row class="text-center">
                    <b-col>
                      <label class="form-group">{{$tr('profilePicture','Profile Picture')}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="text-center">
                      <ImageViewer
                          class="mb-1 img-fluid"
                          v-if="form.profileImage.value"
                          :min-height="100"
                          :max-height="195"
                          :max-width="200"
                          :src="form.profileImage.value.url"
                          :enable-zoom-in="true"
                          :zoom="true"
                          :remove="true"
                          :edit="true"
                          @removeImage="setProfileImageAsNull"
                          @editImage="editProfileImage"
                          @zoomImage="imageZoom"
                          :read-only-inputs="readOnlyMode"
                      >
                      </ImageViewer>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="form-group">
                      <FileUpload
                          data-test-path="file-upload"
                          @file-selected="avatarSelected"
                          ref="avatarUpload"
                          :read-only="readOnlyMode"
                      />
                    </b-col>
                  </b-row>
                </b-col>
                <b-col lg="6">
                  <reach-input
                      data-test-path="add-new-first-name"
                      :label="$tr('basicDataEditor.firstName','First Name')"
                      :placeholder="$tr('basicDataEditor.enter-firstName','Enter first name')"
                      :formField="form.firstName"
                      :read-only="readOnlyMode"
                      :initial-focus="true"
                  >
                  </reach-input>

                  <div class="centredSpinner">
                    <transition name="fade">
                      <b-spinner
                          class="editUserSpinner" v-if="!user && mode==='EDIT_AS_USER'"
                          variant="primary"
                          label="Spinning"
                      ></b-spinner>
                    </transition>
                  </div>

                  <reach-input
                      data-test-path="add-new-last-name"
                      :label="$tr('basicDataEditor.lastName','Last Name')"
                      :placeholder="$tr('basicDataEditor.enter-lastName','Enter last name')"
                      :formField="form.lastName"
                      :read-only="readOnlyMode"
                  >
                  </reach-input>


                </b-col>

              </b-row>
              <b-row>

                <b-col cols="6" v-if="form.showSubType">
                  <ReachSelect
                      ref="subTypeInput"
                      :formField="form.subscriptionType"
                      :field-config="subscriptionTypeFieldConfig"
                      :read-only="subTypeEditable"
                      :editor-mode="true"
                      :label="subscriptionTypeFieldConfig.labelOnly ? '\u00A0' : subscriptionTypeFieldConfig.fieldLabel"
                      :hint="subscriptionTypeFieldConfig.labelOnly ? '' :subscriptionTypeFieldConfig.shortHelpText"
                      :help-title="subscriptionTypeFieldConfig.labelOnly ? '' : subscriptionTypeFieldConfig.helpWindowTitle"
                      :help-message="subscriptionTypeFieldConfig.labelOnly ? '' :subscriptionTypeFieldConfig.htmlHelpText"
                      :initialFocus="subscriptionTypeFieldConfig.autofocus"
                      :options="form.subscriptionTypeOptions"
                      :grid-editor="false"
                      :open-from-grid="false"
                  ></ReachSelect>
                </b-col>
                <b-col :cols="form.showSubType || (mode === 'NEW') ? 6 : 12">
                  <reach-input
                      data-test-path="add-new-initials"
                      :label="$tr('basicDataEditor.initials','Initials')"
                      :placeholder="$tr('basicDataEditor.enter-initials','Enter Initials')"
                      :formField="form.initials"
                      :read-only="readOnlyMode"
                  >
                  </reach-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <reach-input
                      :style="form.profileImage.value ? 'padding-top: 19px' : ''"
                      data-test-path="add-new-email"
                      :label="$tr('basicDataEditor.email','Email')"
                      :placeholder="$tr('basicDataEditor.enter-email','Enter email')"
                      :formField="form.email"
                      :read-only="readOnlyMode"
                  >
                  </reach-input>
                  <b-form-checkbox
                      :disabled="setCheckboxStatus()"
                      v-if="mode === 'NEW'"
                      v-model="status"
                      value="accepted"
                      unchecked-value="not_accepted"
                      class="pb-3"
                  >
                    {{$tr('sendInvitationEmail','Send invitation email.')}}
                  </b-form-checkbox>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <reach-input
                      data-test-path="add-new-login"
                      v-if="mode !== 'EDIT_AS_USER'"
                      :label="$tr('basicDataEditor.login','Login')"
                      :placeholder="$tr('basicDataEditor.enter-login','Enter login')"
                      :formField="form.login"
                      :read-only="readOnlyMode"
                  >
                  </reach-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <reach-input
                      data-test-path="add-new-phone-number"
                      :label="$tr('basicDataEditor.phoneNumber','Phone Number')"
                      :placeholder="$tr('basicDataEditor.enter-phoneNumber','Enter phone number')"
                      :formField="form.phone"
                      :read-only="readOnlyMode"
                  >
                  </reach-input>
                </b-col>
              </b-row>
              <b-row v-if="mode == 'EDIT_AS_USER' && !readOnlyMode">
                <b-col>
                  <div class="alert alert-warning" role="alert">
                    {{$tr('basicDataEditor.info-session-will-restarted','If you update password, your session will be restarted.')}}
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <reach-input
                      data-test-path="add-new-password"
                      :help-title="$tr('basicDataEditor.help.password','Password')"
                      :help-message="passwordHelp"
                      :label="$tr('basicDataEditor.enter-new-password','Enter a new password')"
                      :formField="form.password"
                      :hint="$tr('basicDataEditor.info-password-specification','Min 6 characters; mix at least two of: capital/small/number/special character')"
                      type="password"
                      autocomplete="new-password"
                      :read-only="readOnlyMode"
                  >
                  </reach-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <reach-input
                      data-test-path="add-new-password2"
                      :label="$tr('basicDataEditor.repeat-new-password','Repeat a new password')"
                      :help-title="$tr('basicDataEditor.help.title-repeat-password','Repeat password')"
                      :help-message="$tr('basicDataEditor.help.passwords.match','Both passwords need to match')"
                      :formField="form.password2"
                      :hint="$tr('basicDataEditor.hint.passwords.match','Both passwords need to match')"
                      type="password"
                      autocomplete="new-password"
                      :read-only="readOnlyMode"
                  >
                  </reach-input>
                </b-col>
              </b-row>
              <b-row class="mt-3" v-if="userId">
                <b-col class="text-center">
                  <b-table-simple>
                    <b-tr style="background-color: lightgrey; font-weight: bold">{{$tr('sssignedRoles','Assigned roles')}}</b-tr>
                    <b-tr sticky-column v-for="role in listOfUserRoles" :key="role.id">
                      <b-td>
                        {{ role.name }}
                      </b-td>
                    </b-tr>
                  </b-table-simple>
                </b-col>
                <b-col class="text-center">
                  <b-table-simple>
                    <b-tr style="background-color: lightgrey; font-weight: bold">{{$tr('activeDeputies','Active deputies')}}</b-tr>
                    <b-tr sticky-column v-for="roleAndUserWhoDelegatedInfo in listOfUserDelegation" :key="roleAndUserWhoDelegatedInfo.__key">
                      <b-td>
                        {{ roleAndUserWhoDelegatedInfo.role.name + ' - ' + roleAndUserWhoDelegatedInfo.userWhoDelegated.login }}
                      </b-td>
                    </b-tr>
                  </b-table-simple>
                </b-col>
              </b-row>

              <b-row v-if="mode === 'EDIT_AS_ADMIN'" class="pt-3 pb-2">
                <b-col class="px-3">
                  <b-alert show>{{$tr("BasicDataEditor.integration.account","Integration accounts can only login using integration keys. " +
                      "Login using regular password is disabled for integration accounts.")}}
                  </b-alert>
                </b-col>
              </b-row>

              <b-row v-if="mode === 'EDIT_AS_ADMIN'" class="pb-2">
                <b-col>
                  <b-form-checkbox :disabled="readOnlyMode"
                                   v-model="form.integrationAccount.value"
                  >
                    {{$tr("integrationAccount","Integration account")}}
                  </b-form-checkbox>
                </b-col>
              </b-row>

              <b-row v-if="mode === 'EDIT_AS_ADMIN' && form.integrationAccount.value" class="pb-1">
                <b-col>

                  <div class="form-control grey-label readonly-input">
                    <div v-text="tokenValue"></div>
                  </div>

                </b-col>
              </b-row>
              <b-row v-if="mode === 'EDIT_AS_ADMIN' && form.integrationAccount.value" class="pb-4">
                <b-col>
                  <b-button
                      variant="plm-tertiary"
                      :class="'size-button'"
                      @click="showToken">
                    <font-awesome-icon icon="key"></font-awesome-icon>
                    <span v-if="tokenValue === '******'">{{$tr('show','Show')}}</span>
                    <span v-else>Hide</span>
                  </b-button>
                  <b-button v-if="!readOnlyMode"
                            variant="plm-danger"
                            :class="'size-button'"
                            @click="resetToken">Reset
                  </b-button>
                </b-col>
              </b-row>

              <b-row v-if="mode !== 'EDIT_AS_USER'">
                <b-col>
                  <AttachmentsList
                      data-test-path="attachments-list"
                      @list-of-attachments="openAttachments"
                      :number-of-attachments="numberOfAttachments"
                      :unsaved-attachments="numberOfUnsavedAttachments"
                      :attachment-lists="attachmentLists"
                      :read-only="readOnlyMode"
                      :field-config="attachmentFormFieldConfig"
                  ></AttachmentsList>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="text-center">
                  <label v-if="changedProfilePicture" class="text-danger" style="font-size: 17px">{{$tr("basicDataEditor.saveChanges","Save changes to keepprofile picture")}}
                  </label>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
        </b-row>
      </b-container>
    </v-box>

    <FooterNavbar data-test-path="basic-editor-footer" v-if="showFooter">
      <CloseButton :read-only="readOnlyMode" @close="close"></CloseButton>
      <save-and-close-button
          v-if="!readOnlyMode"
          :enabled="form.canSubmit && errorOwnerFeedback.length <= 0"
          :mode="mode === 'EDIT_AS_USER' || mode === 'EDIT' ? 'EDIT' : 'NEW'"
          @save="save"
      ></save-and-close-button>
    </FooterNavbar>
  </div>
</template>

<script>
import ApplicationUser from "@/server/com/silkplm/model/users/ApplicationUser";
import DashboardUserForm from "@/components/users/DashboardUserForm";
import FileUpload from "@/components/FileUpload";
import RpcInputValidationException from "@/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException";
import VBox from "@/components/VBox";
import ReachInput from "@/components/inputs/ReachInput";
import ImageViewer from "@/components/img/ImageViewer";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import PermissionsSet from "@/server/PermissionsSet";
import {getFileSizeFormatter} from "@/components/datagrid/ColumnFormatter";
import AttachmentsList from "@/components/list/AttachmentsList";
import Events from "@/utils/Events";
import DialogManager from "@/utils/DialogManager";
import ActivityManager from "@/activity/ActivityManager";
import FooterButton from "@/components/navbar/FooterButton";
import CloseButton from "@/components/navbar/CloseButton";
import ActivityHeader from "@/components/layout/ActivityHeader";
import HeaderRow from "@/components/layout/HeaderRow";
import FormHeader from "@/components/forms/FormHeader";

const PinturaImageEditor = () => require("@/components/img/PinturaImageEditor");
const SlideShow = () => require("@/components/img/SlideShow");
import SaveAndCloseButton from "@/components/navbar/SaveAndCloseButton";
import {editAttachmentsActivity} from "@/components/forms/renderers/attachments/AttachmentsUtils";
import FormsLoader from "@/components/forms/FormsLoader";
import {runtimeTr} from "@/utils/Tr";
import ReachSelect from "@/components/inputs/ReachSelect.vue";
import {SILKPLM_DESIGNER, SILKPLM_FREE, SILKPLM_STANDARD, SUB_TYPE_ENTERPRISE} from "@/utils/SessionManager";
import Rpc from "@/Rpc";


const FORM_TYPE = ApplicationUser;

export default {
  name: "BasicDataEditor",
  components: {
    ReachSelect,
    SaveAndCloseButton,
    FormHeader,
    HeaderRow,
    ActivityHeader,
    FooterButton, AttachmentsList, FooterNavbar, FileUpload, VBox, ReachInput, ImageViewer, CloseButton
  },

  created() {

  },

  async mounted() {
    for(let config of this.formConfig.fields){
      if(config.fieldName === "attachments"){
        this.attachmentFormFieldConfig = config;
      }
      if(config.fieldName === "subscriptionType"){
        this.subscriptionTypeFieldConfig = config;
      }
    }

    if(this.mode === 'NEW'){
      this.form.showSubType = true;
      await this.form.setPlanOptions();
    }

    this.readOnlyMode = this.readOnlyInputs;
    if (this.userId && this.mode === "EDIT_AS_USER") {
      await this.loadAttachments();
    }
    if (this.mode === "EDIT_AS_ADMIN") {
      this.$onEvent(Events.attachmentLoad, () => this.loadAttachments());
    }
    if (this.userId) {
      this.listOfUserRoles = await Rpc.Roles.listRolesForApplicationUser(this.userId);
      this.listOfUserRoles.forEach(role =>{
       role.name = runtimeTr("api.roles."+role.name, role.name);
      })
      this.listOfUserDelegation = await Rpc.plm.services.DelegationService.listActiveDelegationUserRoleBindingForUser(this.userId);
      this.listOfUserDelegation.forEach(delegatedRole =>{
        delegatedRole.role.name = runtimeTr("api.roles."+delegatedRole.role.name, delegatedRole.role.name)
      })
      if (this.listOfUserDelegation?.length) {
        for (let roleAndUserWhoDelegatedInfo of this.listOfUserDelegation) {
          let role = roleAndUserWhoDelegatedInfo.role;
          let duplicatedDelegationRoles = _.filter(this.listOfUserDelegation, {'name': role.name});
          if (duplicatedDelegationRoles) {
            for (let index = 0; index < duplicatedDelegationRoles.length; index++) {
              if (!duplicatedDelegationRoles[index].__key) {
                duplicatedDelegationRoles[index].__key = duplicatedDelegationRoles[index].id + "/" + index;
              }
            }
          } else {
            role.__key = role.id;
          }
        }
      }
    }
  },

  methods: {


    async showToken() {
      if (this.mode === "EDIT_AS_ADMIN") {
        if (this.tokenValue === '******') {
          this.tokenValue = await Rpc.Integrations.showToken(this.userId);
        } else {
          this.tokenValue = '******';
        }
      }
    },

    async resetToken() {
      if (this.mode === "EDIT_AS_ADMIN") {
        if (await DialogManager.yesNo($tr('basicDataEditor.info.reset-token','Token reset confirmation'),
            $tr('basicDataEditor.info-token','If you reset token, all integrations using that token will ' +
                'stop to work until you update the token. Do you like to reset the token?'))) {

          this.tokenValue = await Rpc.Integrations.resetToken(this.userId);
        }
      }
    },

    async openHelpDialog() {
      await DialogManager.help($tr('password','Password'), this.passwordHelp);
    },

    setCheckboxStatus() {
      return this.form.email.value === '' || this.form.email.validationInProgress || !this.form.email.isValid
    },

    isEmailShouldBeSend() {
      return this.form.email.value !== '' && this.form.email.isValid
    },

    async avatarSelected() {
      let avatarUpload = this.$refs.avatarUpload;
      let file = avatarUpload.getFile();
      avatarUpload.setProgress(0);
      try {
        this.form.profileImage.value = await Rpc.Users.uploadImage(file).lock().onProgress((e) => {
          avatarUpload.setProgress(e.percent);
        });
        avatarUpload.reset();
      } catch (e) {
        if (e instanceof RpcInputValidationException) {
          avatarUpload.setError(e.fields.image.errorMessage);
        }
      }
    },

    edit() {
      this.readOnlyMode = false;
      this.$emit('edit-enable');
    },

    close() {
      this.$emit('cancel');
    },

    async prepareSave() {
      if (this.status === 'accepted' && this.isEmailShouldBeSend()) {
        this.$emit('send-invitation-email');
      }
      if (this.isProfileImageDeleted && !this.form.profileImage.value && this.userId) {
        await this.deleteProfileImage();
      }
    },

    async saveNoClose() {
      await this.prepareSave();
      this.$emit('ok-no-close', this.attachmentLists);
      this.readOnlyMode = true;
    },

    async save() {
      await this.prepareSave();
      this.$emit('ok', this.attachmentLists);
    },

    async deleteProfileImage() {
      if (SessionManager.applicationUser.id === this.userId) {
        await Rpc.Users.deleteProfileImageOnMyAccount();
      } else {
        await Rpc.Users.deleteProfileImageOnUser(this.userId);
      }
    },

    async saveNewProfileImage(file) {
      if (SessionManager.applicationUser.id === this.userId) {
        await Rpc.Users.saveProfileImageOnMyAccount(file);
      } else {
        await Rpc.Users.saveProfileImageOnUser(this.userId, file);
      }
    },

    setProfileImageAsNull() {
      this.form.profileImage.value = null;
      this.isProfileImageDeleted = true;
    },

    async editProfileImage() {
      let result = await (await ActivityManager.showActivity(PinturaImageEditor, {
        image: this.form.profileImage.value,
        singleImageEditor: true,
        uploadImage: async (image) => await Rpc.Users.uploadImage(image).lock()

      })).getResult();

      if (result) {
        this.form.profileImage.value = result.newFile;
        this.changedProfilePicture = true;
      }
    },

    async imageZoom() {
      let slideShow = await ActivityManager.showActivity(SlideShow, {
        image: this.form.profileImage.value,
        singleImageEditor: true,
        uploadImage: async (image) => await Rpc.Users.uploadImage(image).lock()
      });
      slideShow.$on("new-image", (image) => {
        this.form.profileImage.value = image;
        this.changedProfilePicture = true;
      });
    },

    async openAttachments() {
      let userAttachmentsList = [];
      if (this.userId) {
        userAttachmentsList = this.form.originalSource.attachments;
      }

      if (this.attachmentLists != null && this.attachmentLists.length > 0) {
        this.listOfAttachmentsGrid = this.attachmentLists;
      } else {
        this.listOfAttachmentsGrid = [];
      }

      let result = await editAttachmentsActivity(
          this.listOfAttachmentsGrid, //attachments
          $tr('userAttachments','User attachments'), //title
          !this.readOnlyMode, //editmode
          false,  //readonly
          null, //validatedField
          (file) => Rpc.BusinessEntities.uploadAttachment(file), //  attachmentUploadFunction
          async (attachmentDialogResult) => {  // attachmentSaveFunction
            if (this.userId) {
              attachmentDialogResult.attachmentsList = await Rpc.Users.saveAttachments(this.userId, attachmentDialogResult.attachmentsList);
            }
            this.form.attachments = attachmentDialogResult.attachmentsList;
            this.attachmentLists = attachmentDialogResult.attachmentsList;
            this.numberOfAttachments = this.attachmentLists.length;
            this.numberOfUnsavedAttachments = 0; //attachmentDialogResult.numberOfUnsavedAttachments;
            this.$emit('attachments-saved', this.attachmentLists);

          }
      );


    },

    async loadAttachments() {
      if (this.form.originalSource.attachments) {
        this.numberOfAttachments = this.form.originalSource.attachments.length;
        this.attachmentLists = [...this.form.originalSource.attachments];
      }

      if (this.attachmentLists !== null) {
        for (let i = 0; i < this.attachmentLists.length; i++) {
          this.attachmentLists[i].data.size = getFileSizeFormatter(this.attachmentLists[i].data.size);
        }
      }
    },

    isValid() {
      return this.form.canSubmit && this.errorOwnerFeedback.length <= 0;
    }

  },

  props: {
    cancel: Function,
    ok: Function,

    form: {type: DashboardUserForm, default: null},
    mode: {type: String, default: null},
    editUser: {default: null},
    saveButtonType: {type: String, default: "Save"},
    userId: {type: String, default: ""},
    isEmailClicked: {type: Boolean, default: false},
    errorOwnerFeedback: {type: String, default: ""},
    readOnlyInputs: {type: Boolean, default: null},

    savePerm: {type: Boolean, default: false},
    cancelPerm: {type: Boolean, default: false},
    editPerm: {type: Boolean, default: false},
    showFooter: {type: Boolean, default: true},

  },

  watch: {
    userId: async function () {
      //await this.afterMounted();
    },
    readOnlyMode: function (val) {
      if (val) {
        this.form.password.value = "";
        this.form.password2.value = "";
      }
    }
  },

  data: () => ({
    formConfig: FormsLoader.detectFormConfig(FORM_TYPE),
    FORM_TYPE,
    ADD_AND_CLOSE_LABEL:$tr("add","Add"),
    SAVE_AND_CLOSE_LABEL:$tr("Save","Save"),
    readOnlyMode: false,
    /** @type{FileInRepository[]} */
    listOfAttachmentsGrid: [],
    listOfUserRoles: [],
    listOfUserDelegation: [],
    attachmentLists: [],
    originalLists: [],
    user: new ApplicationUser(),
    isProfileImageDeleted: false,
    status: 'accepted',
    permissions: new PermissionsSet(),
    numberOfAttachments: 0,
    numberOfUnsavedAttachments: 0,
    changedProfilePicture: false,
    tokenValue: "******",
    passwordHelp:
        `<div> Min 6 characters; Mix at least two of: <br>
                <ul style="display: inline-block">
                    <li>capital</li>
                    <li>small</li>
                    <li>number</li>
                    <li>special char</li>
                </ul>
         </div>`,
    showSubType: null,
    subTypeEditable: false,
    attachmentFormFieldConfig: null,
    subscriptionTypeFieldConfig: null,
    subscriptionTypeFieldConfigOptions: []
  })
}
</script>

